// 浮点数精度处理
export function precisionFloat (num, precision = 12) {
  return +parseFloat(num.toPrecision(precision))
}

/**

 */

/**
 *  雪碧图 class 处理
 * @param {String} sprite
 * @returns
 * @description const x = classes('sprite-class')
 * @description x('ccc')       // sprite-class sprite-class-ccc
 * @description x('ccc','aaa') // sprite-class sprite-class-ccc aaa
 */
export const classes = (sprite) => {
  return function (son, ...otherClass) {
    son = son && `${sprite}-${son}`
    return [sprite, son, ...otherClass].filter(Boolean).join(' ')
  }
}

/**
 * 浏览器复制文本
 * @param { String } text | 文本内容
 * @param { function } callback | 回调函数
 */
export const copyText = (text, callback) => {
  const Input = document.createElement('input')
  Input.value = text
  document.body.appendChild(Input)
  Input.select()
  document.execCommand('Copy')
  document.body.removeChild(Input)
  const isCallback = callback && typeof callback === 'function'
  isCallback && callback()
}
